import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
const PageActivitiesMetadataQuery = registerQuery({
  fieldName: 'pageActivitiesMetadata',
  fetcher: ({
    pageId
  }) => {
    return http.get('activities/v2/reports/all-pages/metadata', {
      query: {
        f: pageId,
        useForeignIndex: true
      }
    }).then(({
      metadata
    }) => metadata);
  }
});
const useHubDbContentUrl = ({
  pageId
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(PageActivitiesMetadataQuery, {
    variables: {
      pageId
    },
    skip: !pageId
  });
  const hubDbContentUrl = useMemo(() => {
    var _data$pageActivitiesM;
    return (data === null || data === void 0 || (_data$pageActivitiesM = data.pageActivitiesMetadata[pageId]) === null || _data$pageActivitiesM === void 0 ? void 0 : _data$pageActivitiesM.URL) || '';
  }, [data, pageId]);
  return useMemo(() => ({
    hubDbContentUrl,
    hubDbContentUrlRequestLoading: loading,
    hubDbContentUrlRequestError: error
  }), [hubDbContentUrl, error, loading]);
};
export default useHubDbContentUrl;